import { Stack } from "@mui/material";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

export function NewsFeedEmptyPageState() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={8}
      height="100%"
      textAlign="center"
      sx={{ textWrap: "balance" }}
    >
      <Illustration type="person-destructive" />
      <Text variant="body1">Nothing here, add some friends to see their activity!</Text>
    </Stack>
  );
}
